import { Map, fromJS } from "immutable";
import * as actionTypes from "~/store/action_types";

const files = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.ADD_FILES_SUCCESS:
    case actionTypes.FETCH_FILE_SUCCESS:
    case actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS:
    case actionTypes.PROJECT_TEMPLATE_APPLY_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { files } = entities;

      if (files) {
        return state.merge(fromJS(files));
      }

      return state;
    }
    case actionTypes.FETCH_FILES_AND_ATTACHMENTS_SUCCESS: {
      const { page, response = {} } = action;
      const { entities = {} } = response;
      const { files = {} } = entities;

      const filteredFiles = Object.fromEntries(
        Object.entries(files).filter(([_key, value]) => /File$/i.test(value.class))
      );

      const remappedFiles = {};
      Object.keys(filteredFiles).forEach((key) => {
        remappedFiles[filteredFiles[key].id] = filteredFiles[key];
      });

      if (remappedFiles) {
        return page > 1 ? state.merge(fromJS(remappedFiles)) : fromJS(remappedFiles);
      }

      return state;
    }
    case actionTypes.MOVE_TO_TRASH_SUCCESS:
    case actionTypes.RESTORED_FROM_TRASH_SUCCESS: {
      const { response = {}, objectType } = action;
      const { entities = {}, result = {} } = response;
      const { files = {} } = entities;
      const { single: id } = result;
      if (id > 0 && objectType === "File") {
        return state.merge(fromJS(files));
      }
      return state;
    }
    case actionTypes.PERMANENTLY_DELETE_SUCCESS: {
      const { id = 0, objectType } = action;

      if (id > 0 && objectType === "File") {
        return state.delete(`${id}`);
      }

      return state;
    }
    case actionTypes.DELETE_PROJECT_TEMPLATE_ELEMENT_SUCCESS: {
      const { id = 0, template_id } = action;

      if (id > 0 && state.has(`${id}`) && state.get(`${id}`).get("template_id") === template_id) {
        return state.delete(`${id}`);
      }

      return state;
    }
    case actionTypes.MOVE_FILE_SUCCESS:
    case actionTypes.EDIT_FILE_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { files = {} } = entities;
      const { single: id } = result;
      if (id > 0) {
        return state.merge(fromJS(files));
      }
      return state;
    }
    case actionTypes.FETCH_PROJECT_TEMPLATE_ELEMENTS_SUCCESS:
    case actionTypes.BATCH_ADD_PROJECT_TEMPLATE_FILES_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { projectTemplateElements = {} } = entities;

      const filteredFiles = Object.fromEntries(
        Object.entries(projectTemplateElements).filter(([_key, value]) => /File$/i.test(value.class))
      );
      if (filteredFiles) {
        return state.merge(fromJS(filteredFiles));
      }

      return state;
    }
    default: {
      return state;
    }

    case actionTypes.DATA_OBJECT_DELETED_SUCCESS: {
      const { id = 0, objectType } = action;

      if (id > 0 && (objectType === "LocalFile" || objectType === "DropboxFile" || objectType === "GoogleDriveFile")) {
        return state.delete(`${id}`);
      }

      return state;
    }
  }
};

export default files;
